import { StateCreator } from 'zustand';
import type { DetailsResponse, DetailsSourceResponse, GaugeChartsResponse, OmnichannelPreferences } from '../types';

export type DataState = {
  omnichannelGaugeChartsData: GaugeChartsResponse;
  omnichannelDetailsData: DetailsResponse;
  omnichannelPreferences: OmnichannelPreferences;
  omnichannelSourcesData: DetailsSourceResponse;
};

const defaultGaugeCharts: GaugeChartsResponse = {
  appsProprios: {
    produtos: {
      comparados: 0,
      selecionados: 0,
    },
    percentual: {
      total: 0,
      diff: 0,
    },
  },
  appsEntrega: {
    produtos: {
      comparados: 0,
      selecionados: 0,
    },
    percentual: {
      total: 0,
      diff: 0,
    },
  },
};

export const dataInitialState: DataState = {
  omnichannelGaugeChartsData: defaultGaugeCharts,
  omnichannelDetailsData: [],
  omnichannelPreferences: {
    tipoPreco: 'PRECO_PAGO',
  },
  omnichannelSourcesData: {
    content: [],
    sort: {
      empty: false,
      sorted: false,
      unsorted: false,
    },
    pageable: {
      offset: 0,
      sort: {
        empty: false,
        sorted: false,
        unsorted: false,
      },
      paged: false,
      pageNumber: 0,
      pageSize: 0,
      unpaged: false,
    },
  },
};

export const createDataSlice: StateCreator<DataState> = () => ({
  ...dataInitialState,
});
